import React, {useState} from 'react'
import { observer } from 'mobx-react-lite'
import ReactRender from 'MODULES/_react-render'
import {OpeningDaysCalendarToday} from './display/OpeningDaysCalendarToday'
import {OpeningDaysCalendarThisWeek} from './display/OpeningDaysCalendarThisWeek'
import OpeningDaysCalendarSlider from './display/OpeningDaysCalendarSlider'

ReactRender.registerComponent('OpeningDaysCalendarToday', OpeningDaysCalendarToday)
ReactRender.registerComponent('OpeningDaysCalendarThisWeek', OpeningDaysCalendarThisWeek)
ReactRender.registerComponent('OpeningDaysCalendarSlider', OpeningDaysCalendarSlider)



ReactRender.render()